module.exports = "data:image/gif;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIuLi9pbWcvY2hyaXMuZ2lmIjs="


//////////////////
// WEBPACK FOOTER
// ./src/_assets/img/chris.gif
// module id = 36
// module chunks = 0